
import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getVehiclePreview } from '../api/vehicleAPI';
import { AppContext } from '../context/AppContext';

import Container from '../components/common/Container';
import Loader from '../components/common/Loader';
import PlacaDisplayHeader from '../components/consulta/PlacaDisplayHeader';
import InfoSection from '../components/consulta/InfoSection';
import LockedValue from '../components/consulta/LockedValue';
import UpsellBanner from '../components/consulta/UpsellBanner';
import InfoItem from '../components/common/InfoItem';
import SupportSection from '../components/pagamento/SupportSection';

// ✅ Importação de todos os ícones necessários
import { FaCar, FaFingerprint, FaUser, FaInfoCircle, FaFileContract, FaGavel, FaTag, FaHistory } from 'react-icons/fa';

const PageWrapper = styled.main`
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.5;
  color: #2D3436;
  background-color: #F8F9FA;
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 110px;
`;

const HeaderInfo = styled.div`
  background: ${({ theme }) => theme.colors.primaryLight};
  color: white;
  padding: 15px;
  border-radius: ${({ theme }) => theme.radii.sm};
  margin-bottom: 30px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

// ✅ Mapeamento ATUALIZADO para as chaves da sua API real
const DADOS_VEICULO_CONFIG = {
  "Placa": { "label": "Placa", "locked": false },
  "Placa Modelo Antigo": { "label": "Placa Modelo Antigo", "locked": true },
  "Marca": { "label": "Marca", "locked": false },
  "Modelo": { "label": "Modelo", "locked": false },
  "Versão": { "label": "Versão", "locked": false },
  "Cor": { "label": "Cor", "locked": true },
  "Ano de Fabricação": { "label": "Ano de Fabricação", "locked": false },
  "Ano do Modelo": { "label": "Ano do Modelo", "locked": false },
  "Chassi": { "label": "Chassi", "locked": false },
  "Combustível": { "label": "Combustível", "locked": false },
  "Quantidade de Passageiros": { "label": "Quantidade de Passageiros", "locked": true },
  "Município": { "label": "Município", "locked": true },
  "UF da Placa": { "label": "UF da Placa", "locked": true },
  "Potência": { "label": "Potência", "locked": true },
  "Cilindradas": { "label": "Cilindradas", "locked": true },
  "Tipo de Veículo": { "label": "Tipo de Veículo", "locked": true },
  "Tipo de Montagem": { "label": "Tipo de Montagem", "locked": true },
  "Peso Bruto Total (PBT)": { "label": "Peso Bruto Total (PBT)", "locked": true },
  "Capacidade de Carga": { "label": "Capacidade de Carga", "locked": true },
  "Capacidade Máxima de Tração (CMT)": { "label": "Capacidade Máxima de Tração (CMT)", "locked": true },
  "Situacao do Veículo": { "label": "Situação do Veículo", "locked": true },
  "Situacao do Chassi": { "label": "Situação do Chassi", "locked": true }
};



const ConsultaPage = () => {
  const { placa } = useParams();
  const navigate = useNavigate();
  const { setVehicleQuery } = useContext(AppContext);
  const [vehicleData, setVehicleData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setVehicleQuery({ placa });
    const fetchPreview = async () => {
      setLoading(true);
      try {
        const data = await getVehiclePreview(placa);
        console.log('Dados recebidos do backend:', data);
        
        // Extrair os dados do objeto "Dados recebidos"
        const dadosVeiculo = data["Dados recebidos"] || data;
        console.log('Dados do veículo extraídos:', dadosVeiculo);
        
        setVehicleData(dadosVeiculo); 
      } catch (error) {
        console.error("Falha ao buscar os dados do veículo:", error);
        setVehicleData(null);
      } finally {
        setLoading(false);
      }
    };
    if (placa) fetchPreview();
  }, [placa, setVehicleQuery]);

  const handleUnlock = () => navigate(`/pagamento-itens/${placa}`);

  if (loading) return <Loader />;

  return (
    <PageWrapper>
      <Container>
        <HeaderInfo>
            <FaInfoCircle />
            <span>Esta consulta preliminar mostra informações básicas. Para acessar todos os dados, desbloqueie o relatório completo.</span>
        </HeaderInfo>
        <PlacaDisplayHeader placa={placa} onDownload={handleUnlock} />
        {!vehicleData ? (
          <h2>Não foram encontrados dados para a placa informada.</h2>
        ) : (
          <>
            <InfoSection title="Informações Principais" icon={<FaCar />}>
              {Object.entries(DADOS_VEICULO_CONFIG).map(([key, config]) => {
                const value = vehicleData[key];
                if (config.locked) {
                  return (
                    <LockedValue
                      key={key}
                      label={config.label}
                      onClick={handleUnlock}
                    />
                  );
                }
                return value ? (
                  <InfoItem
                    key={key}
                    label={config.label}
                    value={String(value)}
                  />
                ) : null;
              })}
            </InfoSection>
            <InfoSection title="Identificação" icon={<FaFingerprint />}>
                <LockedValue label="Renavam" onClick={handleUnlock} />
                <LockedValue label="Chassi" onClick={handleUnlock} />
                <LockedValue label="Final do Chassi" onClick={handleUnlock} />
                <LockedValue label="Origem" onClick={handleUnlock} />
                <LockedValue label="Cilindradas" onClick={handleUnlock} />
                <LockedValue label="Potência" onClick={handleUnlock} />
                <LockedValue label="Peso Bruto Total" onClick={handleUnlock} />
                <LockedValue label="Capacidade de Carga" onClick={handleUnlock} />
                <LockedValue label="Cap Máxima Tração" onClick={handleUnlock} />
                <LockedValue label="Tipo Carroceria" onClick={handleUnlock} />
                <LockedValue label="Situação Veículo" onClick={handleUnlock} />
                <LockedValue label="Situação Chassi" onClick={handleUnlock} />
                <LockedValue label="Tipo de Montagem" onClick={handleUnlock} />
                <LockedValue label="Transmissão" onClick={handleUnlock} />
                <LockedValue label="Número de Portas" onClick={handleUnlock} />
                <LockedValue label="Local de Fabricação" onClick={handleUnlock} />
                <LockedValue label="Região Geográfica" onClick={handleUnlock} />
                <LockedValue label="País de Origem" onClick={handleUnlock} />
                <LockedValue label="Dígito Verificador Chassi" onClick={handleUnlock} />
                <LockedValue label="Validação Serial Chassi" onClick={handleUnlock} />
                <LockedValue label="Número de Eixos" onClick={handleUnlock} />
                <LockedValue label="Tipo de Veículo" onClick={handleUnlock} />
                <LockedValue label="Categoria" onClick={handleUnlock} />
                <LockedValue label="Espécie" onClick={handleUnlock} />
                <LockedValue label="Capacidade de Passageiros" onClick={handleUnlock} />
                <LockedValue label="Município (Faturamento)" onClick={handleUnlock} />
                <LockedValue label="UF (Faturamento)" onClick={handleUnlock} />
                <LockedValue label="Documento Faturado" onClick={handleUnlock} />
                <LockedValue label="Tipo Documento Importadora" onClick={handleUnlock} />
                <LockedValue label="Restrições" onClick={handleUnlock} />
            </InfoSection>

            <InfoSection title="Proprietário" icon={<FaUser />}>
               <LockedValue label="Nome do Proprietário" onClick={handleUnlock} />
               <LockedValue label="Documento Proprietário" onClick={handleUnlock} />
               <LockedValue label="Tipo doc. Proprietário" onClick={handleUnlock} />
               <LockedValue label="Tipo doc. Faturado" onClick={handleUnlock} />
               <LockedValue label="Estado/UF Faturado" onClick={handleUnlock} />
               <LockedValue label="CNPJ Faturado" onClick={handleUnlock} />
            </InfoSection>
            
            <InfoSection title="Outras Informações" icon={<FaInfoCircle />}>
                <LockedValue label="Situação Roubo/Furto" onClick={handleUnlock} />
                <LockedValue label="Município" onClick={handleUnlock} />
                <LockedValue label="Estado UF" onClick={handleUnlock} />
                <LockedValue label="Número do Motor" onClick={handleUnlock} />
                <LockedValue label="Categoria" onClick={handleUnlock} />
            </InfoSection>

           <InfoSection title="Gravame" icon={<FaFileContract />}>
                <LockedValue label="Situação Gravame" onClick={handleUnlock} />
                <LockedValue label="Tipo de Restrição Financeira" onClick={handleUnlock} />
                <LockedValue label="Nome do Agente Financeiro" onClick={handleUnlock} />
                <LockedValue label="Documento do Agente Financeiro" onClick={handleUnlock} />
                <LockedValue label="Nome do Financiado" onClick={handleUnlock} />
                <LockedValue label="Documento do Financiado" onClick={handleUnlock} />
                <LockedValue label="Data de Inclusão" onClick={handleUnlock} />
                <LockedValue label="UF do Gravame" onClick={handleUnlock} />
                <LockedValue label="Número do Gravame" onClick={handleUnlock} />
            </InfoSection>

            <InfoSection title="Histórico de Leilão" icon={<FaGavel />}>
                <LockedValue label="Data do Leilão" onClick={handleUnlock} />
                <LockedValue label="Número do Leilão" onClick={handleUnlock} />
                <LockedValue label="Comitente" onClick={handleUnlock} />
                <LockedValue label="Leiloeiro" onClick={handleUnlock} />
                <LockedValue label="UF do Leilão" onClick={handleUnlock} />
                <LockedValue label="Chance de Vistoria Especial" onClick={handleUnlock} />
                <LockedValue label="Percentual de Aceitação" onClick={handleUnlock} />
                <LockedValue label="Percentual sobre Tabela FIPE" onClick={handleUnlock} />
            </InfoSection>

            <InfoSection title="Tabela FIPE" icon={<FaTag />}>
                <LockedValue label="Marca/Modelo FIPE" onClick={handleUnlock} />
                <LockedValue label="Ano Modelo" onClick={handleUnlock} />
                <LockedValue label="Combustível" onClick={handleUnlock} />
                <LockedValue label="Código FIPE" onClick={handleUnlock} />
                <LockedValue label="Vigência da Tabela FIPE" onClick={handleUnlock} />
                <LockedValue label="Preço FIPE" onClick={handleUnlock} />
                <LockedValue label="Preço Médio" onClick={handleUnlock} />
            </InfoSection>

            <InfoSection title="Histórico de Veículos por CPF/CNPJ" icon={<FaHistory />}>
                <LockedValue label="Placa" onClick={handleUnlock} />
                <LockedValue label="Cidade" onClick={handleUnlock} />
                <LockedValue label="Estado (UF)" onClick={handleUnlock} />
                <LockedValue label="Renavam" onClick={handleUnlock} />
                <LockedValue label="Chassi" onClick={handleUnlock} />
                <LockedValue label="Número do Motor" onClick={handleUnlock} />
                <LockedValue label="Ano de Fabricação" onClick={handleUnlock} />
                <LockedValue label="Ano Modelo" onClick={handleUnlock} />
                <LockedValue label="Procedência" onClick={handleUnlock} />
                <LockedValue label="Espécie" onClick={handleUnlock} />
                <LockedValue label="Combustível" onClick={handleUnlock} />
                <LockedValue label="Cor" onClick={handleUnlock} />
                <LockedValue label="Marca/Modelo" onClick={handleUnlock} />
            </InfoSection>

            <UpsellBanner onClick={handleUnlock} />
            <SupportSection />
          </>
        )}
      </Container>
    </PageWrapper>
  );
};

export default ConsultaPage;